export default __webpack_public_path__ + "static/media/Logo.843847d9.webp";